import { ThemeConfig } from './theme';

export type HEX = string;

export type ColorsConfig = {
  'Neutral/0': HEX;
  'Neutral/20': HEX;
  'Neutral/30': HEX;
  'Neutral/50': HEX;
  'Neutral/70': HEX;
  'Neutral/80': HEX;
  'Neutral/90': HEX;
  'Neutral/100': HEX;
  'Blue/10': HEX;
  'Blue/20': HEX;
  'Blue/30': HEX;
  'Blue/50': HEX;
  'Blue/70': HEX;
  'Blue/80': HEX;
  'Blue/90': HEX;
  'Purple/10': HEX;
  'Purple/20': HEX;
  'Purple/30': HEX;
  'Purple/50': HEX;
  'Purple/70': HEX;
  'Purple/80': HEX;
  'Purple/90': HEX;
  'Teal/10': HEX;
  'Teal/20': HEX;
  'Teal/30': HEX;
  'Teal/50': HEX;
  'Teal/70': HEX;
  'Teal/80': HEX;
  'Teal/90': HEX;
  'Green/10': HEX;
  'Green/20': HEX;
  'Green/30': HEX;
  'Green/50': HEX;
  'Green/70': HEX;
  'Green/80': HEX;
  'Green/90': HEX;
  'Yellow/10': HEX;
  'Yellow/20': HEX;
  'Yellow/30': HEX;
  'Yellow/50': HEX;
  'Yellow/70': HEX;
  'Yellow/80': HEX;
  'Yellow/90': HEX;
  'Red/10': HEX;
  'Red/20': HEX;
  'Red/30': HEX;
  'Red/50': HEX;
  'Red/70': HEX;
  'Red/80': HEX;
  'Red/90': HEX;
};

export type PredefinedColor = keyof ColorsConfig;
export type Color = PredefinedColor | HEX;

export const resolveColor =
  (theme: ThemeConfig) =>
  (color: Color): HEX => {
    if (color in theme.colors) {
      const colorKey = color as PredefinedColor;
      return theme.colors[colorKey];
    }
    return color as HEX;
  };
